/*global angular*/
module.exports = [function () {
  'use strict';
  return {
    restrict: 'E',
    template: require('./section.html'),
    replace: true,
    transclude: true,
    scope: {
      content: '=data',
      find: '=',
      level: '='
    },
    link: function (scope) {
    }
  };
}];




// WEBPACK FOOTER //
// ./web/js/module/visionText/js/section/section.js